module.exports = "/_next/static/images/OctoDiagram-xs-ea2a28808274da842c71b0472363dc6b.webp";